import axios from "axios";
import { BrowserStorage } from "../LocalStorage/BrowserStorage";
import { IStore } from "../LocalStorage/IStore";
import { SoapUtils } from "../../utils/SoapUtils";

export interface IBaseRequest {
    server: string;
    session: string;
    cancelSource: any;
    toXml(): string;
}
export class BaseRequest implements IBaseRequest {
    private _store:IStore;
    public server: string;
    public session: string;
    public cancelSource: any;

    constructor(_server: string, _session: string) {
        this._store = new BrowserStorage();
        this.server = _server;
        this.session = _session;
        this.cancelSource = axios.CancelToken.source();
    }
    protected get isRemembered():boolean{
        return this._store.Username !== '' && this._store.Password !== '';
    }
    
    protected wrapperXml(method:string, xml:string):string{
        return `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:wsdl="http://atollon.com/enterprise/wsdl">
        <soapenv:Header/>
        <soapenv:Body>
           <wsdl:${method}>
              ${xml}
           </wsdl:${method}>
        </soapenv:Body>
     </soapenv:Envelope>`;
    }

    toXml() {
        return SoapUtils.makeNode(this.server, 'server') + SoapUtils.makeNode(this.session, 'session');
    }

    protected makeNode = (variable: any, tagName: string): string => SoapUtils.makeNode(variable, tagName);
    protected makeNodeDate = (variable: Date | undefined, tagName: string): string => SoapUtils.makeNodeDate(variable, tagName);
    protected makeNodeArray = (variable: any[] | undefined, itemFunction: (item: any) => string, tagName:string = ''): string => SoapUtils.makeNodeArray(variable, itemFunction, tagName);
}